import { ToastIntent } from "@fluentui/react-components";
import { IApiContext } from "../interfaces/IApiContext";
import { IAuthContext } from "../interfaces/IAuthenticate";
import { IDataContext } from "../interfaces/IDataContext";
import { ICustomer } from "../interfaces/ICustomer";

export const fetchInitialData = async (
  dataContext: IDataContext,
  apiContext: IApiContext,
  auth: IAuthContext,
  t: any
) => {
  if (await hasValidToken(auth)) {
    const user = auth.user;
    await apiContext.userApi.getById(dataContext, user, t).then(async (res) => {
      const customers: ICustomer[] = res?.customers ?? [];
      const storedCustomerId = localStorage.getItem(`selectedCustomer_${user.id}`);
      const selectedCustomer: ICustomer | undefined =
        (storedCustomerId ? customers.find((c) => String(c.id) === storedCustomerId) : undefined) ?? customers[0];

      if (selectedCustomer) {
        dataContext.setRootState((prev) => ({ ...prev, selectedCustomer }));
        await Promise.all([
          apiContext.customerOrderApi.getOrders(dataContext, user, selectedCustomer, t),
          apiContext.customerOrderApi.getTickets(dataContext, user, selectedCustomer, t),
        ]);
      }
    });
  } else {
    onExpiredSession(dataContext, auth);
  }
};

const onExpiredSession = (dataContext: IDataContext, auth: IAuthContext) => {
  const intent: ToastIntent = "info";
  const msg = "info.tokenExpired";
  auth.logout(dataContext, intent, msg);
};

const hasValidToken = async (auth: IAuthContext) => {
  return await auth.validateToken(auth?.user?.token);
};
